module.exports = __webpack_public_path__ + "client/img/office_03.3c0d0961.png";